"use client";

import * as React from "react";
import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "src/components/ui/dropdown-menu";
import { cn } from "@/src/utils/shadcn";
import { usePathname, useRouter } from "next/navigation";
import Cookies from "cookies-js";

const activeClasses = cn("bg-primary text-white");

export function LangToggle() {
  const pathname = usePathname();
  const router = useRouter();

  // Get the current language prefix from the pathname
  const currentLang = pathname.split("/")[1] || "en";

  const handleLanguageChange = (lang: string) => {
    const newLang = lang === "en" ? "ar" : "en";

    // Update the path to include the new language prefix
    const segments = pathname.split("/");
    segments[1] = newLang; // Replace the current language with the new one
    const newPathname = segments.join("/") || `/${newLang}`;

    // Use next/navigation's router to push the new language route
    router.push(newPathname);
    window.location.href = newPathname;
  };

  React.useEffect(()=>{
    Cookies.set("lang", currentLang);
}, [currentLang])

  return (
    <div className="fixed right-2 z-99" style={{ top: "43%" }}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div
            role="button"
            aria-haspopup="true"
            aria-label="language switcher"
            className="grid h-12 w-12 cursor-pointer place-items-center rounded-5 bg-primary p-0 text-white hover:bg-primary-light"
          >
            <Globe className="h-[1.2rem] w-[1.2rem]" />
            <span className="sr-only">Toggle language</span>
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          className="z-111 bg-white dark:border-accent-900 dark:bg-accent-700"
        >
          <DropdownMenuItem
            className={cn(currentLang === "en" && activeClasses)}
            onClick={() => handleLanguageChange("ar")}
          >
            English
          </DropdownMenuItem>
          <DropdownMenuItem
            className={cn(currentLang === "ar" && activeClasses)}
            onClick={() => handleLanguageChange("en")}
          >
            العربية
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
